<template>
  <div class="relative w-full h-56 overflow-hidden group cursor-pointer" @click="openManage">
    <img class="h-full w-full object-cover" :src="image" alt="Newsbild" />
    <div
      class="absolute inset-0 group-hover:opacity-50 transition-opacity duration-150"
      :style="{
        background:
          'linear-gradient(0deg, ' +
          hexToRgbA((entry.published ? category.color : '#333333'), 0.8) +
          ' 0%, ' +
          hexToRgbA((entry.published ? category.color : '#333333'), 0) +
          ' 80%)',
      }"
    />
    <div class="absolute top-0 inset-x-0 text-white p-2 leading-tight">
      <div v-if="!entry.published">
        <icon name="NotVisible" size="1.5em" />
      </div>
    </div>
    <div class="absolute bottom-0 inset-x-0 text-white p-2 leading-tight grid grid-cols-1-auto">
      <div
        :style="{
          textShadow:
            '2px 2px 6px ' +
            hexToRgbA((entry.published ? category.color : '#333333'), 1) +
            ', 1px 1px 4px rgba(0,0,0,0.8)',
        }"
      >
        <div class="font-medium tracking-wider uppercase">
          <span>{{ entry.title }}</span>
        </div>
        <div v-if="entry.published_at" class="text-xs tracking-wide font-light">
          {{ entry.published_at | formatDate }}
        </div>
      </div>
      <div class="self-end">
        <icon :name="category.icon" size="2em" />
      </div>
    </div>
  </div>
</template>

<script>
import DateMixin from "@/mixins/DateMixin";

import { NewsEntry } from "@/modules/news/viewmodels/NewsEntry";
import { NewsCategory } from "@/modules/news/viewmodels/NewsCategory";

export default {
  name: "NewsEntry",
  mixins: [DateMixin],
  data() {
    return {
      image: null
    };
  },
  props: {
    entry: {
      type: NewsEntry,
      required: true
    },
    category: {
      type: NewsCategory,
      required: true
    }
  },
  components: {},
  methods: {
    hexToRgbA(hex, opacity) {
      var c;
      if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
        c = hex.substring(1).split("");
        if (c.length == 3) {
          c = [c[0], c[0], c[1], c[1], c[2], c[2]];
        }
        c = "0x" + c.join("");
        return (
          "rgba(" +
          [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(",") +
          ", " +
          opacity +
          ")"
        );
      }
      throw new Error("Bad Hex");
    },
    openManage() {
      this.goTo("/news-manage/" + this.entry.id);
    }
  },
  computed: {},
  async created() {
    if (this.entry && this.entry.image_id) {
      this.image = this.entry.image;
    } else {
      this.image = this.category.image;
    }
  }
};
</script>
